import React from 'react';

const GradientFlow = () => {
  return (
    <div className="w-full h-full relative overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(45deg, rgba(0, 255, 209, 0.3), rgba(111, 210, 192, 0.2), transparent)',
            animation: 'gradientFlow 15s ease infinite'
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(-45deg, transparent, rgba(0, 255, 209, 0.2), transparent)',
            animation: 'gradientFlow 20s ease infinite reverse'
          }}
        />
      </div>
    </div>
  );
};

export default GradientFlow;